import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import { stringToDate } from 'modules/core/lib/dates'

import GraphqlContract from 'modules/contracts/lib/graphqlContract'

const calculateGraphqlContracts = (
  graphqlContractVersions: ContractVersionPageContractVersionFragment[]
): GraphqlContract[] => {
  return graphqlContractVersions.reduce((contracts: GraphqlContract[], contractVersion) => {
    // If is the first version we need to create a contract
    if (contracts.length === 0)
      contracts.unshift(new GraphqlContract(contractVersion.effectiveOn || ''))

    // End date is inclusive. Thus, we take next day as reference
    const firstDayWithoutContract = contracts[0]?.endsOn?.clone().add(1, 'day')
    if (firstDayWithoutContract && firstDayWithoutContract.isBefore(contractVersion.effectiveOn)) {
      // Adding in first position as contracts are shown from newest to oldest
      contracts.unshift(new GraphqlContract(contractVersion.effectiveOn || ''))
    }

    const currentContract = contracts[0]
    if (currentContract) {
      currentContract.pushVersion(contractVersion)
      currentContract.endsOn = contractVersion.endsOn
        ? stringToDate(contractVersion.endsOn, 'backend')
        : null
    }

    return contracts
  }, [])
}

export default calculateGraphqlContracts
